import { GetUsersByRoleInput } from 'generated/graphql';
import { sortBy } from 'lodash';
import { useGetUsersByRoleLazyQuery } from 'pages/users/api/queries/generated/GetUsersByRole';
import { useEffect, useMemo, useState } from 'react';

export const useUsersByRole = (input: GetUsersByRoleInput) => {
  const [hasMore, setHasMore] = useState(true);
  const [offset, setOffset] = useState(0);

  const [getUsersByRole, { data, loading, error, fetchMore }] = useGetUsersByRoleLazyQuery({
    variables: { input },
  });

  useEffect(() => {
    getUsersByRole();
  }, [getUsersByRole]);

  const loadMore = async () => {
    if (!data?.getUsersByRole.users.length || loading || !hasMore) return;

    const newOffset = offset + (input.limit || 20);
    setOffset(newOffset);

    try {
      const result = await fetchMore({
        variables: {
          input: {
            ...input,
            offset: newOffset,
          },
        },
        updateQuery: (prev, { fetchMoreResult }) => {
          if (!fetchMoreResult) return prev;

          const newUsers = fetchMoreResult.getUsersByRole.users;
          if (newUsers.length === 0) {
            setHasMore(false);
            return prev;
          }

          return {
            getUsersByRole: {
              ...prev.getUsersByRole,
              users: [...prev.getUsersByRole.users, ...newUsers],
              count: fetchMoreResult.getUsersByRole.count,
            },
          };
        },
      });

      setHasMore(result.data.getUsersByRole.users.length > 0);
    } catch (e) {
      console.error('Error loading more users:', e);
      setHasMore(false);
    }
  };

  const users = useMemo(() => sortBy(data?.getUsersByRole.users, el => el.lastname), [data?.getUsersByRole.users]);

  return {
    users,
    count: data?.getUsersByRole.count,
    loading,
    error,
    hasMore,
    loadMore,
  };
};
